<div class="container">
  <div class="header">
    <span class="header__title">Базисы поставки</span>
  </div>

  <div class="table-header-wrapper">
    <span>Базис</span>
    <span>Название</span>
    <span>Станция отгрузки</span>
    <span>Производитель</span>
  </div>

  <div class="content" data-cy="basis-overlay-content">
    <div
      #contentRows
      class="table-content-wrapper"
      *ngFor="let shipment of shipments; let i = index"
      [prlwBasisOverlayTooltip]="shipment"
      [tooltipType]="getTooltipType(i)"
      (click)="add(shipment.code, i)"
    >
      <span class="table-content-wrapper__basis">{{ shipment.code }}</span>
      <span class="table-content-wrapper__overflow">{{
        shipment.briefDescription ?? '-'
      }}</span>
      <span class="table-content-wrapper__overflow">{{ shipment.name }}</span>
      <span class="table-content-wrapper__overflow">{{ shipment.plants }}</span>
    </div>
  </div>

  <div class="footer">
    <button
      class="add-basis-button"
      data-cy="basis-overlay-add-all-button"
      (click)="addAll()"
    >
      <prlw-icon name="round-plus" class="add-basis-button__icon"></prlw-icon>
      Добавить все базисы
    </button>
  </div>
</div>
